module.exports = __webpack_public_path__ + "img/camion.3dcae2c9.png";